import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { commonThemeBackgroundClass } from '../../../core/utilities/color';

@Component({
    selector: 'app-stack-separator',
    template: '',
    styleUrls: ['./stack-separator.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StackSeparatorComponent {

  @HostBinding('class')
  protected get classes(): string {
    return commonThemeBackgroundClass('foreground');
  }

}
